.inlineClickableText {
  color: var(--mantine-color-brand-6);
  font-size: var(--mantine-font-size-sm);
  font-style: normal;
  font-weight: 600;
}
